import UtilityFunction from '../Util/Util';

const { responseFormat } = UtilityFunction;

const basePath = 'instruction';
const pathList = {
    list: `/`,
};

const dummy = [
    "Pilih Variasi Kemasan sesuai kebutuhan.",
    "Pilih ukuran yang diinginkan.",
    "Unggah (upload) desainmu ke dalam website. Kami merekomendasikan file dalam format PDF supaya resolusinya tinggi.",
    "Masukkan nomor WhatsApp aktif. Tim kami akan menghubungi kamu nantinya untuk mengkonfirmasi besaran dan letak konten desain.",
    "Lakukan pembayaran dengan pilihan metode yang tersedia."
];

for(let key in pathList) {
    pathList[key] = basePath + pathList[key];
}

const instructionList = async () => {
    try {
        // const apiPath = pathList.category;
        // const category = await api.getCall(apiPath);

        // return category;
        return responseFormat(0, "Successfully get instruction list!", dummy);
    } catch(e) {
        console.log(e.toString());
        return responseFormat(-1, "Failed to get instruction list!", []);
    }
};

const instructionAPI = {
    instructionList
}

export default instructionAPI;